<template>
  <VList
    v-bind="{ ...$props, ...$attrs }"
    dense
    class="w-list"
  >
    <slot />
    <VListItemGroup>
      <slot name="content" />
    </VListItemGroup>
  </VList>
</template>

<script>
import { VList, VListItemGroup } from 'vuetify/lib';

export default {
  name: 'WorkList',
  props: {
    ...VList.options.props
  },
  components: {
    VList,
    VListItemGroup
  },
};
</script>
<style lang="scss" scoped>
.w-list .v-list-item__icon {
  margin-right: 1rem;
  display: flex;
  align-items: center;
}
</style>
